export default __webpack_public_path__ + "static/media/ifcom.abdf797c.jpg";